export const languageOptions: Record<string, string> = {
  Afrikaans: "Afrikaans",
  Albanian: "Albanian",
  Arabic: "Arabic",
  Armenian: "Armenian",
  Azeri: "Azeri",
  Basque: "Basque",
  Belarusian: "Belarusian",
  Bulgarian: "Bulgarian",
  Catalan: "Catalan",
  "Chinese (S)": "Chinese (S)",
  "Chinese (T)": "Chinese (T)",
  Croatian: "Croatian",
  Czech: "Czech",
  Danish: "Danish",
  Divehi: "Divehi",
  Dutch: "Dutch",
  English: "English",
  Esperanto: "Esperanto",
  Estonian: "Estonian",
  Faroese: "Faroese",
  Farsi: "Farsi",
  Finnish: "Finnish",
  French: "French",
  "French (Canada)": "French (Canada)",
  "FYRO Macedonian": "FYRO Macedonian",
  Galician: "Galician",
  Georgian: "Georgian",
  German: "German",
  Greek: "Greek",
  Gujarati: "Gujarati",
  Hebrew: "Hebrew",
  Hindi: "Hindi",
  Hungarian: "Hungarian",
  Icelandic: "Icelandic",
  Indonesian: "Indonesian",
  Italian: "Italian",
  Japanese: "Japanese",
  Kannada: "Kannada",
  Kazakh: "Kazakh",
  Konkani: "Konkani",
  Korean: "Korean",
  Kyrgyz: "Kyrgyz",
  Latvian: "Latvian",
  Lithuanian: "Lithuanian",
  Malay: "Malay",
  Maltese: "Maltese",
  Maori: "Maori",
  Marathi: "Marathi",
  Mongolian: "Mongolian",
  "Northern Sotho": "Northern Sotho",
  Norwegian: "Norwegian",
  Pashto: "Pashto",
  Polish: "Polish",
  Portuguese: "Portuguese",
  Punjabi: "Punjabi",
  Quechua: "Quechua",
  Romanian: "Romanian",
  Russian: "Russian",
  Sami: "Sami",
  Sanskrit: "Sanskrit",
  Serbian: "Serbian",
  Slovak: "Slovak",
  Slovenian: "Slovenian",
  Spanish: "Spanish",
  "Spanish (Mexico)": "Spanish (Mexico)",
  Swahili: "Swahili",
  Swedish: "Swedish",
  Syriac: "Syriac",
  Tagalog: "Tagalog",
  Tamil: "Tamil",
  Tatar: "Tatar",
  Telugu: "Telugu",
  Thai: "Thai",
  Tsonga: "Tsonga",
  Tswana: "Tswana",
  Turkish: "Turkish",
  Ukrainian: "Ukrainian",
  Urdu: "Urdu",
  Uzbek: "Uzbek",
  Vietnamese: "Vietnamese",
  Welsh: "Welsh",
  Xhosa: "Xhosa",
  Zulu: "Zulu"
};

export const languageOptionsList = Object.keys(languageOptions);
